import { render, staticRenderFns } from "./UpdateOfficer.vue?vue&type=template&id=537b6c10&scoped=true&"
import script from "./UpdateOfficer.vue?vue&type=script&lang=js&"
export * from "./UpdateOfficer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOfficer.vue?vue&type=style&index=0&id=537b6c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b6c10",
  null
  
)

export default component.exports